const Button = {
  baseStyle: {
    fontWeight: 'normal',
    _disabled: {
      bg: 'additional.primary.dark.disabled',
    },
    _hover: {
      bg: 'additional.primary.dark.hover',
    },
  },
  variants: {
    primary: {
      bg: 'primary.main',
      color: 'white',
    },
    secondary: {
      bg: '#DAE0E5',
      color: 'black',
      _hover: {
        bg: '#C4CDD5',
      },
    },
    outlined: {
      border: '1px solid #C4CDD5',
      _hover: {
        bg: '#DAE0E5',
      },
    },
    critical: {
      bg: 'critical.300',
      color: 'white',
      _disabled: {
        bg: 'critical.200',
      },
      _hover: {
        bg: 'critical.400',
      },
    },
    normal: {
      bg: 'transparent',
      color: 'text.main',
      _hover: {
        bg: '#F1F4F7',
      },
      _active: {
        bg: 'E7ECF1',
      },
      _disabled: {
        bg: 'transparent',
        opacity: 0.4,
      }
    }
  },
  defaultProps: {
    variant: 'primary',
  },
};

export default Button;
